import { genericRoute } from 'utils/routeUtils';

import OtherSportsHomePage from './containers/OtherSportsHomePage';
import OtherSportsNav from './nav/OtherSportsNav';

export default genericRoute(OtherSportsHomePage, OtherSportsNav, 'other-sports');



// WEBPACK FOOTER //
// ./modules/OtherSports/routes.js